import {
  ShippingCoverageZodSchema,
  type ShippingCoverageInterface,
} from "@redotech/redo-model/integration/redo-in-shipping/ris";
import { ShopifyExchangePaymentStrategy } from "@redotech/redo-model/shopify";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export interface GetShopifyIntegrationSettingsDef {
  name: "getShopifyIntegrationSettings";
  input: z.ZodObject<{
    teamId: z.ZodType<string>;
    integrationType: z.ZodString;
  }>;
  output: z.ZodObject<{
    risIntegration: z.ZodNullable<ShippingCoverageInterface>;
    hasShopifyIntegration: z.ZodBoolean;
    isRisEnabled: z.ZodBoolean;
    exchangePaymentStrategy: z.ZodNullable<
      z.ZodType<ShopifyExchangePaymentStrategy>
    >;
  }>;
}

export const GetShopifyIntegrationSettingsResponseSchema = z.object({
  risIntegration: (
    ShippingCoverageZodSchema as ShippingCoverageInterface
  ).nullable(),
  hasShopifyIntegration: z.boolean(),
  isRisEnabled: z.boolean(),
  exchangePaymentStrategy: z
    .nativeEnum(ShopifyExchangePaymentStrategy)
    .nullable(),
});
export type GetShopifyIntegrationSettingsResponse = z.infer<
  typeof GetShopifyIntegrationSettingsResponseSchema
>;

export const getShopifyIntegrationSettings: GetShopifyIntegrationSettingsDef = {
  name: "getShopifyIntegrationSettings" as const,
  input: z.object({ teamId: zExt.objectId(), integrationType: z.string() }),
  output: GetShopifyIntegrationSettingsResponseSchema,
};
